import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-feed-sentinel-agreement-dialog',
  templateUrl: './feed-sentinel-agreement-dialog.component.html',
  styleUrls: ['./feed-sentinel-agreement-dialog.component.scss'],
})
export class FeedSentinelAgreementDialogComponent {
  title: string;
  message: string;
  agreeLabel: string;
  cancelLabel: string;

  constructor(
    private dialogRef: MatDialogRef<FeedSentinelAgreementDialogComponent, 'agree' | 'cancel'>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title = data?.title || 'Confirmation';
    this.message = data?.message || 'The selected feed requires both Sentinel-1 (SAR) and Sentinel-2 (MSI) data. Do you want to continue?';
    this.agreeLabel = data?.agreeLabel || 'Agree';
    this.cancelLabel = data?.cancelLabel || 'Cancel';
  }

  agree(): void {
    this.dialogRef.close('agree');
  }

  cancel(): void {
    this.dialogRef.close('cancel');
  }
}
